// Heuristiques locales du widget de support : elles complètent le classifieur
// LLM (`classifyAndSuggestAction`), qui retombe parfois en "conversation"
// alors que l'utilisateur a besoin d'un humain. Elles ne servent qu'à décider
// quelle option afficher sous la réponse (ticket / roadmap) — jamais à
// répondre à la place de l'IA.

/** Problème technique net → proposer un ticket. */
export const BUG_HINTS =
  /\b(bug|erreur|plante|crash|cass[eé]|cassée|ne (marche|fonctionne) pas|ne s[‘’ ]enregistre|ne se (charge|lance)|impossible de|je n[‘’ ]arrive pas|page blanche|blanc[h]? d[‘’ ]ecran|probl[eè]me technique|message d[‘’ ]erreur|perd (mon|ma|mes))\b/i;

/**
 * Demande d'ajout explicite → proposer la roadmap. Volontairement restrictive
 * (verbes d'ajout) pour ne pas classer des questions normales en feature.
 */
export const FEATURE_HINTS =
  /\b(j[‘’ ]aim(e|erais).*ajouter|ce serait.*bien.*ajouter|pourriez-vous ajouter|pouvez-vous ajouter|feature request|nouvelle fonctionnalit[eé]|il manque.*pouvoir|on devrait pouvoir ajouter)\b/i;

/**
 * Demandes que le bot ne peut pas traiter seul (fr / en / es) : parler à un
 * humain, facturation, remboursement, compte ou données personnelles. Elles
 * doivent toujours déboucher sur un ticket.
 *
 * Pas de `\b` devant les mots accentués : en JS, `\b` ne connaît que [A-Za-z0-9_].
 */
export const HUMAN_OR_ACCOUNT_HINTS =
  /parler (?:à|a|avec) (?:quelqu|un humain|une personne|un conseiller|un agent|(?:l['’])?[ée]quipe|le support)|contacter (?:l['’]?[ée]quipe|le support|un humain|quelqu)|factur|invoice|billing|rembours|refund|reembols|\b(?:tva|vat|rgpd|gdpr)\b|supprim\w* (?:mon|le) compte|delete (?:my|the) account|eliminar (?:mi|la) cuenta|(?:talk|speak) (?:to|with) (?:a human|someone|somebody|a person|an agent|the team|support)|hablar con (?:alguien|una persona|un humano|el equipo|un agente)/i;

/**
 * La réponse de l'assistant recommande un ticket (« créez un ticket »,
 * « open a ticket », « abrir un ticket »…). Dans ce cas le bouton doit être
 * affiché, quel que soit l'avis du classifieur.
 */
export function replyMentionsTicket(reply: string | null | undefined): boolean {
  return !!reply && /\btickets?\b/i.test(reply);
}
